import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'

export default function CreateDialog({openCreateColor, setOpenCreateColor, handleCreate}) {
    const user = JSON.parse(localStorage.getItem('user'))
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          colorName: "",
        },
      });

    return (
        <form>
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenCreateColor(false)} open={openCreateColor}>
                <DialogTitle id='dialog-title'>
                    Create Color
                </DialogTitle>
                <DialogContent>
                <TextField
                    id="colorName"
                    type="text"
                    margin="dense"
                    value={values.colorName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Color"
                />
                {errors.colorName && touched.colorName && (
                    <p className="error">{errors.colorName}</p>
                )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => {
                            setOpenCreateColor(false)
                            values.colorName = ""
                        }}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => {
                            //create new color
                            handleCreate(values.colorName)
                            //reset color name value
                            values.colorName = ""
                        }}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}